<template>
    <svg viewBox="0 0 1024 1024" fill="currentColor" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
        <path d="M646.4 358.4a248.746667 248.746667 0 0 0-249.6 248.32v250.88a38.4 38.4 0 0 0 38.4 38.4h89.6a38.4 38.4 0 0 0 38.4-38.4v-250.88a82.773333 82.773333 0 0 1 91.733333-82.346667 85.333333 85.333333 0 0 1 74.666667 85.333334v247.893333a38.4 38.4 0 0 0 38.4 38.4h89.6a38.4 38.4 0 0 0 38.4-38.4v-250.88a248.746667 248.746667 0 0 0-249.6-248.32z" />
        <path d="M128 396.8m38.4 0l115.2 0q38.4 0 38.4 38.4l0 422.4q0 38.4-38.4 38.4l-115.2 0q-38.4 0-38.4-38.4l0-422.4q0-38.4 38.4-38.4Z" />
        <path d="M224 224m-96 0a96 96 0 1 0 192 0 96 96 0 1 0-192 0Z" />
    </svg>
</template>

<script>
export default {
    name: "LinkedinIcon",
};
</script>
